'use client';

import type { ValueTransition } from 'motion';
import * as motion from 'motion/react-client';
import React, { startTransition, useEffect, useRef, useState, type JSX } from 'react';

interface ExtraAnimateChangeInHeightProps {
	readonly transition: ValueTransition,
}

export function AnimateChangeInHeightDiv({ children, transition, ...divProps }: ExtraAnimateChangeInHeightProps & Omit<JSX.IntrinsicElements['div'], 'ref'>) {
	const containerRef = useRef<HTMLDivElement | null>(null);
	const [height, setHeight] = useState<number | 'auto'>('auto');
	//console.log('AnimateChangeInHeightDiv initialized with height:', height);

	useEffect(() => {
		if (!containerRef.current) return;

		const resizeObserver = new ResizeObserver((entries) => {
			const observedHeight = entries[0]!.contentRect.height;
			//console.log('ResizeObserver triggered:', { entries, observedHeight });
			startTransition(() => { setHeight(observedHeight) });
		});

		resizeObserver.observe(containerRef.current);

		return () => resizeObserver.disconnect();
	}, []);

	return <motion.div animate={{ height }} transition={{ height: transition }}>
		<div {...divProps} ref={containerRef}>{children}</div>
	</motion.div>;
};
